<template>
  <div class="auth-container">
    <div v-if="typeIndex === 0" class="auth_div">
      <p class="auth_tips">
        <img src="@/assets/img/auth/icon_warning_circle_field.png" alt="">
        实名认证决定账号归属，网络货运实名制下单，请根据实际情况进行实名认证
      </p>
      <div class="itemBox">
        <div class="auth_item">
          <div class="item_top">
            <div>
              <img src="@/assets/img/auth/icon_qiye.png" alt="">
            </div>
            <div>
              <p class="item_name">企业认证 <span>适用于企业、政府、事业单位、团队、组织等账号归属于企业</span></p>
              <p>请提前准备好<span class="item_msg_qi">营业执照</span> <span class="item_msg_qi">法人代表身份证信息</span></p>
              <p>若您有任何问题可联系400-152-5656</p>
            </div>
          </div>
          <div class="auth_bottom">
            <a-button @click="toNext">
            开始认证
            </a-button>
          </div>
        </div>
        <div class="auth_item item_disabled">
          <div class="item_top">
            <div>
              <img src="@/assets/img/auth/icon_geren_disable.png" alt="">
            </div>
            <div>
              <p class="item_name">个人认证 <span>适用于个人用户</span></p>
              <p>请提前准备好<span class="item_msg">个人身份证信息</span></p>
              <p>若您有任何问题可联系400-152-5656</p>
            </div>
          </div>
          <div class="auth_bottom">
            <a-button :disabled="true">
            开始认证
            </a-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="typeIndex === 1" class="form-container">
        <a-form-model 
          ref="ruleForm"
          :rules="rules"
          :model="form"
          layout="vertical"
          class="custom-form">
          <p class="title">企业认证</p>
          <a-form-model-item 
            style="margin-bottom: 4px">
            <span slot="label"><span class="need">*</span> 营业执照</span>
            <Uploads @uplosdImg="uplosdImg" />
            <div class="imgTips">
              <p>限定数量为一张</p>
              <p>大小不超过5M的jpg、jpeg、png格式的图片</p>
              <p>图片清晰并且加盖公章的营业执照</p>
            </div>
          </a-form-model-item>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="企业名称" prop="customerName">
                <a-input v-model="form.customerName"
                  :disabled="imgloading"
                  placeholder="请输入企业名称" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="统一社会信用代码"  prop="creditCode">
                <a-input v-model="form.creditCode"
                  :disabled="imgloading"
                  placeholder="请输入企业统一社会信用代码" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="法定代表人" prop="legalPerson">
                <a-input v-model="form.legalPerson"
                  :disabled="imgloading"
                  placeholder="请输入法定代表人姓名" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="法定代表人身份证号" prop="legalIdNum">
                <a-input v-model="form.legalIdNum"
                  placeholder="请输入法定代表人身份证号" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="法定代表人手机" prop="legalMobile">
                <a-input v-model="form.legalMobile"
                  placeholder="请输入法定代表人11位手机号" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="企业类型" prop="industryTypeCode">
                <a-select
                  v-model="form.industryTypeCode"
                  placeholder="请选择企业类型"
                  @change="changeIndustryType"
                >
                  <a-select-option
                    v-for="item in industryTypeList"
                    :key="item.dictionaryCode"
                    :value="item.dictionaryCode"
                  >
                  {{item.dictionaryName}}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="12">
              <a-form-model-item label="短信验证码" prop="captcha" class="auth-code">
                <a-input v-model="form.captcha" placeholder="请输入验证码" />
                <a-button type="primary" class="auth-code-btn" :disabled="isdis" @click="getAuthCode">{{ AuthCodeText }}</a-button>
              </a-form-model-item>
            </a-col> -->
          </a-row>
          <a-form-model-item prop="checked">
            <span slot="label">
              选择服务
              <span class="type-title">(多选)</span>
            </span>
            <div class="check_div">
              <div v-for="item in BusinessLicense" :key="item.value" :class="filterCheck(item.value) ? 'check_item check_active' : 'check_item'" @click="onChecked(item.value)">
                {{item.label}}
                <img v-if="filterCheck(item.value)" src="@/assets/img/icon_select.png" alt="">
              </div>
            </div>
          </a-form-model-item>
          <div class="btnStyle">
            <a-button size="large"
              class="btn-cancel"
              @click="handleCancel">
              取消
            </a-button>
            <a-button :loading="loading"
              class="btn-submit"
              :disabled="!isUpdata"
              size="large"
              html-type="submit"
              type="primary"
              @click="onSubmit">
              提交企业认证
            </a-button>
            <span class="telTips"><img src="@/assets/img/auth/telephone_num.png" alt=""></span>
          </div>
        </a-form-model>
    </div>
    <div v-if="typeIndex === 2">
      <block-title
        class="topStyle"
        title="认证签约"
      >
        <div class="contentBox">
          <img :src="filterImage()" alt="">
          <span class="text_ok">{{auditStatus[detailData.auditStatus]}}</span>
          <a-button v-if="detailData.auditStatus === statusKey.REJECT" class="text_btn" @click="resetAuth">
            重新认证
          </a-button>
          <p v-if="detailData.auditStatus === statusKey.REJECT" class="reject"><img src="@/assets/img/auth/arrow.png" alt="">{{detailData.rejectReason}}</p>
        </div>
      </block-title>
      <block-title
        class="topStyle maxDiv"
        title="企业信息"
      >
        <div class="contentBox">
          <a-descriptions class="main" bordered :column="2">
            <a-descriptions-item label="企业名称">{{detailData.customerName}}</a-descriptions-item>
            <a-descriptions-item label="统一社会信用代码">{{detailData.creditCode}}</a-descriptions-item>
            <a-descriptions-item label="法定代表人">{{detailData.legalPerson}}</a-descriptions-item>
            <a-descriptions-item label="法定代表人身份证号">{{detailData.legalIdNum}}</a-descriptions-item>
            <a-descriptions-item label="法定代表人手机">{{detailData.legalMobile}}</a-descriptions-item>
            <a-descriptions-item label="企业类型">{{detailData.ext && detailData.ext.industryType}}</a-descriptions-item>
          </a-descriptions>
        </div>
      </block-title>
    </div>
    <a-modal v-model="visible" title="" :closable="false" :footer="null" :mask-closable="false">
      <div class="okTips">
        <img src="@/assets/img/auth/pic_success.png" alt="">
        <p class="tips_title">认证申请提交成功</p>
        <p class="tips_text">请耐心等待，稍后将有工作人员与您联系</p>
        <a-button @click="visible=false">
          知道了
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  sendMsg,
  submitApply,
  submitBusinessLicense,
  getSignDetail,
  getSignType,
} from '@/api/enterprise/authentication'
import BlockTitle from '@/components/panel/BlockTitle.vue'
import picWaiting from '@/assets/img/auth/pic_waiting.png'
import picFail from '@/assets/img/auth/pic_fail.png'
import base from '@/api/base'
import {BusinessLicense, auditStatus, statusKey} from './constant'
import Uploads from './components/upload'

export default {
  name: 'Authentication',
  components: {
    Uploads,
    BlockTitle
  },
  data() {
    return {
      picWaiting,
      visible: false,
      picFail,
      BusinessLicense,
      rules: {
        customerName: [
          {
            required: true,
            message: '请输入正确的企业名称',
            trigger: 'change',
            whitespace: true,
            pattern: /^.{2,50}$/,
          },
        ],
        creditCode: [
          {
            required: true,
            message: '请输入正确的18位统一社会信用代码',
            whitespace: true,
            trigger: 'change',
            len: 18,
          },
        ],
        legalMobile: [
          {
            required: true,
            message: '请输入正确的手机号',
            trigger: 'change',
            pattern: /^\d{11,11}$/
          },
        ],
        legalIdNum: [
          {
            required: true,
            message: '请输入正确的身份证号码',
            trigger: 'change',
            pattern: /^.{18,18}$/
          },
        ],
        legalPerson: [
          {
            required: true,
            message: '请输入正确的法定代表人姓名',
            pattern: /^[\u4e00-\u9fa5]{2,6}$/,
            trigger: 'change',
          },
        ],
        checked: [
          {
            required: true,
            message: '必须选择至少一项服务',
            trigger: 'change',
          },
        ],
        captcha: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'change',
          },
        ],
        industryTypeCode: [
          {
            required: true,
            message: '请选择企业类型',
            trigger: 'change',
          }
        ]
      },
      form: {
        contacts: '',
        legalMobile: '',
        captcha: '',
        ext: [],
        customerName: '',
        creditCode: '',
        legalPerson: '',
        checked: [],
        legalIdNum: ''
      },
      loading: false,
      AuthCodeText: '获取验证码',
      isdis: true,
      upImgData: null,
      imgloading: false,
      state: false,
      typeIndex: 0,
      isUpdata: false,
      auditStatus,
      statusKey,
      detailData: {},
      signData: null,
      industryTypeList: [],
    }
  },
  watch:{
    upImgData(){
      this.verification()
    },
    form: {
      handler(){
          this.verification()
      },
      deep: true
    },
    'form.legalMobile': function(val){
      if(val && val.length === 11){
        this.isdis = false
      }
    }
  },
  created(){
    this.getSignDetail()
    this.getSignType()
    this.getDictionary();
  },
  methods: {
    async getDictionary() {
      const res = await base.getDictionary({
        status: 1,
        type: 'industryType',
      });
      this.industryTypeList = res || [];
    },
    changeIndustryType(val) {
      const current = this.industryTypeList.filter((item) => item.dictionaryCode === val);
      this.form.industryType = current[0]?.dictionaryName;
    },
    toNext(){
      if(this.signData && this.signData?.realNameStatus === null){
        this.$message.warning('线下货主不能认证')
        return 
      }
      this.typeIndex = 1
    },
    async getSignType(){
      // 获取签约状态
      const {customers,creditCode,customerId}=this.$store.state.user
      const data={}
      if(creditCode){
        data.ids=customers.map(item=>item.customerId)
      }else{
        data.ids=[customerId]
      }
      const res = await getSignType(data)
      if(res && res.length > 0){
        [this.signData] = res
      }
    },
    filterImage(){
      if(this.detailData.auditStatus === statusKey.REJECT){
        return this.picFail
      }
      return this.picWaiting
    },
    async getSignDetail(){
      const res = await getSignDetail({
        applyUserId: this.$store.state.user.userId
      })
      if(res) {
        this.typeIndex = 2
        this.detailData = res
      }
    },
    resetAuth(){
      this.typeIndex = 0
    },
    verification(){
      if(!this.upImgData){
         return
      }
      const {legalMobile,customerName,creditCode,legalPerson,checked, industryTypeCode} = this.form
      if( legalMobile && customerName && creditCode && legalPerson && industryTypeCode && checked.length > 0){
        this.isUpdata = true
      }else {
        this.isUpdata = false
      }
    },
    onChecked(value){
      const list = this.form.checked
      if(list.includes(value)){
        this.form.checked.splice(list.indexOf(value), 1)
      } else {
        this.form.checked.push(value)
      }
      this.$refs.ruleForm.validateField(['checked'])
      this.onChangeBus(this.form.checked)
    },
    filterCheck(value){
      return this.form.checked.includes(value)
    },
    onChangeBus(v) {
      const dataList = BusinessLicense
      this.checkedData = {}
      for (let i = 0; i < dataList.length; i += 1) {
        v.map((child) => {
          if (dataList[i].value === child) {
            this.checkedData[dataList[i].label] = 'yes'
          }
          return child
        })
      }
    },
    uplosdImg(v) {
      this.state = false
      this.imgloading = true
      if (v.httpCode !== 200) {
        this.$message.error('营业执照上传失败')
        this.imgloading = false
      } else {
        const [upImgData] = v.data
        this.upImgData = upImgData
        submitBusinessLicense({ url: this.upImgData.url })
          .then((res) => {
            if (res) {
              const { creditCode, enterpriseName, legalPerson, address } = res
              this.imgloading = false
              this.form.customerName = enterpriseName
              this.form.creditCode = creditCode
              this.form.legalPerson = legalPerson
              this.form.address = address
            }
          })
          .catch((res) => {
            if (res.data.httpCode === 400) {
              this.imgloading = false
              this.state = true
            }
          })
      }
    },
    valtips() {},
    // 识别失败提示
    failure() {
      this.$message.error('营业执照识别失败，请重新上传')
    },
    handleCancel() {
      const that = this
      this.$confirm({
        title: '是否退出？',
        content: '您填写的信息尚未提交，请提交后再离开页面。 ',
        onOk() {
          that.typeIndex = 0
        },
        class: 'test',
      })
    },
    // 获取验证码
    getAuthCode() {
      let count = 60
      if (this.form.legalMobile.length !== 11) {
        this.$message.error('联系人手机不能为空!')
        return
      }
      if (this.isdis) return
      this.isdis = true
      let isdistimer = null
      sendMsg({ mobile: this.form.legalMobile }).then(() => {
        isdistimer = setInterval(() => {
          if (count > 0) {
            count -= 1
            this.AuthCodeText = `${count}S后可重新获取`
          } else {
            count = 60
            this.isdis = false
            this.AuthCodeText = '获取验证码'
            clearInterval(isdistimer)
          }
        }, 1000)
      })
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.upImgData) {
            this.$message.error('请上传营业执照')
            return
          }
          if (!this.checkedData) {
            this.$message.error('请选择服务类型')
            return
          }
          const that = this
          const {
            customerName,
            creditCode,
            legalPerson,
            legalMobile,
            // captcha,
            address,
            legalIdNum,
            industryTypeCode,
            industryType,
          } = this.form
          if (!customerName || !creditCode || !legalPerson) {
            this.$message.error('请输入企业认证相关信息')
            return
          }
          // if (!captcha) {
          //   this.$message.error('请输入验证码')
          // }
          submitApply({
            customerName, // 企业名称
            creditCode, // 统一社会信用代码,
            legalPerson, // 法人姓名,
            businessLicenseUrl: that.upImgData.url, // 营业执照图片地址,
            address,  // 企业地址, 非必须
            legalMobile, // 法人手机号,
            legalIdNum, // 法人身份证号
            ext: {
              ...that.checkedData,  // 扩展字段格式如:{"干线":"yes","城配":"no","仓":"yes"}
              industryType, // 客户类型名称
              industryTypeCode, // 客户类型编码
            },
            // captcha, // 短信验证码
            applyUserName: this.$store.state.user.userName, // 申请人
            applyUserId: this.$store.state.user.userId, // 申请人ID
          }).then(() => {
            // this.$router.push('/enterprise/successAuth')
            this.visible = true
            this.typeIndex = 2
            this.getSignDetail()
          })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-layout{
  height: 100%;
}
.auth-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background: #f0f2f5;
  overflow: auto;
  header {
    margin-top: 20px;
    margin-left: 40px;
  }

  .copyright {
    position: relative;
    text-align: center;
    width: 100%;
    margin: 10px 0 40px 0;
    font-size: 14px;
    color: #999999;
  }
}
.auth-container {
  flex: 1;
  // background-color: #fff;
  .welcome {
    font-weight: 400;
    font-size: 26px;
    color: #171717;
    margin: 30px 0 10px 0;
  }
  .form-container {
    margin-top: 10px;
    background: #ffffff;
    padding: 0 24px 10px 24px;
    ::v-deep .ant-btn[disabled]{
      background-color: rgba(6, 184, 128, 0.5);
      color: rgba(255,255,255,0.5);
    }
    .check_div{
      display: flex;
      .check_item{
        cursor: pointer;
        position: relative;
        width: 80px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        margin-right: 12px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #C9CBCE;
        font-size: 14px;
        color: #606266;
        img{
          position: absolute;
          top: 0;
          right: 0;
        }
      }
      .check_active{
        border: 1px solid #06B880;
      }
    }
    .title {
      font-size: 18px;
      color: #171717;
      font-weight: blod;
      padding: 28px 0;
      position: relative;
      &::before{
        content: "";
        position: absolute;
        left: -24px;
        top: 36px;
        width: 4px;
        height: 16px;
        border-radius: 2px;
        background-color: #06b880;
      }
    }
    .need{
      color: #f5222d;
    }
    /deep/.custom-form {
      position: relative;
      .imgTips{
        position: absolute;
        left: 122px;
        top: -45px;
        font-size: 12px;
        color: #A9ABAE;
      }
      .ant-row.ant-form-item {
        margin-bottom: 20px;
      }
      .ant-form-item-label {
        width: 170px;
      }
      .ant-form-item-control-wrapper {
        width: 400px;
      }
      .auth-code {
        .ant-form-item-children {
          display: flex;
        }
        .auth-code-btn {
          margin-left: 10px;
          width: 190px;
        }
      }
    }
    .btn-cancel {
      width: 120px;
    }
  }
  .query-result {
    font-size: 14px;
    color: #606266;
    padding: 0 0 20px 170px;
  }
}
.loadingText {
  margin-left: 20px;
  color: red;
}
.loadingTips {
  position: absolute;
  top: 20px;
}
.type-title {
  color: #ccc;
}

.auth_div{
  .auth_tips{
    width: 528px;
    height: 36px;
    background: #FFEFDE;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 400;
    color: #FB9432;
    line-height: 36px;
    padding: 0 12px;
    margin-bottom: 24px;
  }
  .itemBox{
    width: 100%;
  }
  .auth_item{
    width: 700px;
    height: 284px;
    float: left;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #E7E9EC;
    box-sizing: border-box;
    padding: 40px;
    margin-bottom: 24px;
    &:first-child{
      margin-right: 24px;
    }
    .item_top{
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      font-size: 16px;
      color: #606266;
      img{
        margin-right: 22px;
      }
      .item_name{
        font-size: 24px;
        color: #171717;
        margin-bottom: 20px;
        span{
          font-size: 14px;
          color: #A9ABAE;
          margin-left: 12px;
        }
      }
      .item_msg{
        display: inline-block;
        padding: 4px 12px;
        margin-left: 16px;
        margin-bottom: 5px;
        color: #606266;
        background: #DEF6F1;
        border-radius: 16px;
      }
      .item_msg_qi{
        display: inline-block;
        padding: 4px 12px;
        margin-left: 16px;
        margin-bottom: 5px;
        color: #606266;
        background: #DBEDFF;
        border-radius: 16px;
      }
    }
    .auth_bottom{
      margin-top: 40px;
      text-align: right;
    }
    &:hover{
      box-shadow: 0px 20px 20px 0px rgba(204, 210, 212, 0.5);
    }
  }
  
  .item_disabled{
    .item_top{
      .item_msg{
        background: #F4F5F6;
      }
    }
    &:hover{
      box-shadow: none;
    }
  }
}
.btnStyle{
  position: relative;
  margin-top: 100px;
  margin-bottom: 30px;
  .btn-submit{
    width: 280px;
    margin-left: 32px;
  }
}
.okTips{
  text-align: center;
  .tips_title{
    font-size: 16px;
    color: #171717;
    margin-top: 7px;
  }
  .tips_text{
    font-size: 14px;
    color: #606266;
    margin: 14px 0 32px 0;
  }
}
.topStyle{
  background-color: #fff;
  padding: 24px 0;
  .contentBox{
    padding: 0 32px;
    .text_ok{
      margin: 0 16px 0 24px;
      font-size: 14px;
      font-weight: 600;
      color: #171717;
    }
    .text_btn{
      border-color: #06B880;
      color: #06B880;
    }
  }
  
}
.maxDiv{
  height: 400px;
  margin-top: 24px;
}
.telTips{
  position: absolute;
  right: -36px;
  top: -32px;
}
.reject{
  width: 464px;
  background-color: #F4F5F6;
  border: 1px solid #F0F0F0;
  border-radius: 3px;
  padding: 12px;
  box-sizing: border-box;
  margin-left: 98px;
  color: #606266;
  position: relative;
  img{
    width: 20px;
    height: 8px;
    position: absolute;
    top: -8px;
    left: 23px;
  }
}
</style>
